import * as React from "react";
import { Card, CardContent } from "../ui/card";

type AttHistoryCardsProps = {
  totalDays: number;
  presentDays: number;
  absentDays: number;
  attendancePercentage: number;
};

export default function AttHistoryCards({
  totalDays,
  presentDays,
  absentDays,
  attendancePercentage,
}: AttHistoryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card className="bg-blue-50 dark:bg-blue-600/15 border-none">
        <CardContent className="p-4">
          <div className="text-sm text-blue-600 mb-1">Total Classes</div>
          <div className="text-2xl font-bold">{totalDays}</div>
        </CardContent>
      </Card>
      <Card className="bg-green-50 border-none dark:bg-green-600/15">
        <CardContent className="p-4">
          <div className="text-sm text-green-600 mb-1">Present Days</div>
          <div className="text-2xl font-bold">{presentDays}</div>
        </CardContent>
      </Card>
      <Card className="bg-red-50 border-none dark:bg-red-600/15">
        <CardContent className="p-4">
          <div className="text-sm text-red-600 mb-1">Absent Days</div>
          <div className="text-2xl font-bold"> {absentDays}</div>
        </CardContent>
      </Card>
      <Card className="bg-purple-50 border-none dark:bg-purple-600/15">
        <CardContent className="p-4">
          <div className="text-sm text-purple-600 mb-1">Attendance %</div>
          <div className="text-2xl font-bold">
            {attendancePercentage.toFixed(2)}%
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
